import { render, staticRenderFns } from "./Kontakt.vue?vue&type=template&id=6370c0b5"
var script = {}
import style0 from "./Kontakt.vue?vue&type=style&index=0&id=6370c0b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports